module.exports = __webpack_public_path__ + "static/img/10.8ed86fce.png";